export default "__VITE_ASSET__74fa5180__"